import { useDrawer } from '../Drawer';

type Props = {
  className?: string;
  children: React.ReactNode;
};

export default function DrawerLink({ children, className = '' }: Props) {
  const { toggle } = useDrawer();
  return (
    <a onClick={toggle} className={className}>
      {children}
    </a>
  );
}
